import { motion } from 'framer-motion';
import { FlaskConical } from 'lucide-react';
import Navbar from '../components/Navbar';

export default function Research() {
  return (
    <div className="min-h-screen bg-background dot-bg flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="text-center"
        >
          <div className="relative w-16 h-16 mx-auto mb-6">
            <div className="absolute inset-0 rounded-2xl bg-primary/20 animate-ping" />
            <div className="relative w-16 h-16 rounded-2xl bg-primary/10 border border-primary/30 flex items-center justify-center">
              <FlaskConical size={28} className="text-primary" />
            </div>
          </div>
          <span className="text-xs font-semibold text-primary bg-primary/10 border border-primary/30 px-3 py-1 rounded-full font-mono-cv tracking-widest uppercase mb-4 inline-block">
            In Progress
          </span>
          <h2 className="text-3xl font-extrabold text-foreground mt-4 mb-3" style={{ fontFamily: 'Syne, sans-serif' }}>Research</h2>
          <p className="text-muted-foreground text-sm font-mono-cv">Currently Ongoing...</p>
        </motion.div>
      </div>
    </div>
  );
}